const cancelledError = () => Object.assign(new Error('Request retry cancelled.'), { code: 'AUTO_RETRY_CANCELLED' });

const retryDelay = (error, attempt) => {
  const header = error.response?.headers?.['retry-after'];
  const seconds = header == null ? NaN : Number(header);
  const requested = Number.isFinite(seconds) ? seconds * 1000 : header ? Date.parse(header) - Date.now() : 0;
  return Math.max(1000 * (2 ** attempt), Number.isFinite(requested) ? requested : 0);
};

// Only explicit rate-limit rejections are retried. Callers close over the SAME
// request ID, nonce, revision, payload and headers; an accepted bet is never replayed
// just because a later fairness refresh was throttled.
export const rateLimitedRequest = async (request, { cancelled = () => false, onWait = () => {} } = {}) => {
  for (let attempt = 0; ; attempt += 1) {
    if (cancelled()) throw cancelledError();
    try { return await request(); }
    catch (error) {
      if (error.response?.status !== 429 || attempt >= 5) throw error;
      const delay = retryDelay(error, attempt);
      // Don't retry earlier than a long server Retry-After, or leave a hidden,
      // unbounded wager pending. The caller instead ends the run with an error.
      if (delay > 60000) throw error;
      onWait(Math.ceil(delay / 1000));
      const until = Date.now() + delay;
      while (Date.now() < until) {
        if (cancelled()) throw cancelledError();
        await new Promise((resolve) => setTimeout(resolve, Math.min(100, until - Date.now())));
      }
    }
  }
};